module.exports = __webpack_public_path__ + "media/img/marquee/marquee-home-42ead06fb15be1cd02ef3127966a7e24.jpg";